/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbDatepickerModule,
  NbMenuModule,
  NbSidebarModule,
} from '@nebular/theme';

import { FirebaseService } from './firebase.service';
import { environment } from '../environments/firebaseConfiguration';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import { AuthGuard } from './guard/auth.guard';
import { NavbarComponent } from './navbar/navbar.component';
import { RecordingSymbolComponent } from './recording-symbol/recording-symbol.component';
import { ScanImageSingleComponent } from './scan-image-single/scan-image-single.component';
import { SinglePreviewComponent } from './single-preview/single-preview.component';
import { TransactionTableComponent } from './transaction-table/transaction-table.component';
import { ImageViewerModule } from "ngx-image-viewer";
import { ReactiveFormsModule } from '@angular/forms';
import {NbLayoutModule, NbToastrModule } from '@nebular/theme';
import {HotkeyModule} from 'angular2-hotkeys';
@NgModule({
  declarations: [AppComponent, NavbarComponent, RecordingSymbolComponent, ScanImageSingleComponent, SinglePreviewComponent, TransactionTableComponent,],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireAuthModule,
    AngularFirestoreModule,
    AngularFireStorageModule,
    AngularFireDatabaseModule,
    // ImageViewerModule.forRoot(),
    ImageViewerModule,
    ReactiveFormsModule,
    BrowserModule,
    NbToastrModule.forRoot(),
    NbLayoutModule,
    HotkeyModule.forRoot()
  ],
  bootstrap: [AppComponent],
  providers:[FirebaseService, AuthGuard]
})
export class AppModule {
}
